// NOTE: Modified from ourWork.js filter component
//       Possible candidate for consolidation

const nav = document.querySelector('.playbook__nav') // Previously 'filters'
const navToggle = document.querySelector('.nav-toggle') // Previously 'currentFilter'
const navSections = document.querySelectorAll('.nav-list__section')
const navSectionToggles = document.querySelectorAll('.nav-list__section button') // Previously 'filter'

let isMobile = window.innerWidth <= 1024

// Width check
window.onresize = () => {
   isMobile = window.innerWidth <= 1024

   if (!isMobile) {
       nav.classList.remove('expand')
   }
}

// Close nav on outside clicks
// Only applies below lg breakpoint, see playbook.scss
window.onclick = () => {
    if (!event.target.closest('.playbook__nav') && nav.classList.contains('expand')) {
        nav.classList.remove('expand')

        // Reset sections to only show the current one
        navSections.forEach((section) => {
           if (!section.classList.contains('current') && section.classList.contains('open')) {
               section.classList.remove('open')
           } else if (section.classList.contains('current'))  {
               section.classList.add('open')
           }
        })
    }
}

// Toggle nav
// Only applies below lg breakpoint, see playbook.scss
navToggle.addEventListener('click', () => {
    if (isMobile) {
        nav.classList.toggle('expand')
    }
})

// Toggle sections
for (i = 0; i < navSectionToggles.length; i++) {
    navSectionToggles[i].addEventListener('click', function () {
        let section = event.target.closest('.nav-list__section')

        section.classList.toggle('open')
    })
}

//
// Playbook pagination nav
//

fetch('/api/navs/playbook_nav/tree?site=default&fields=title,url,children')
    .then(response => response.json())
    .then(data => buildPagination(data.data) );

const buildPagination = (data) => {
    const firstPage = data[0].page;

    // Loop through each item in the data array and add children to the pages variable
    let pages = data.map((item) => {
        return item.children;
    }).flat();

    const currentPage = window.location.href.substring(window.location.origin.length);

    // Search pages array for the current page
    const currentPageIndex = pages.findIndex((page) => {
        return page.page.url === currentPage;
    });

    // Get the next and previous page
    const nextPage = pages[currentPageIndex + 1]?.page;
    const prevPage = currentPageIndex === 0 ? firstPage : pages[currentPageIndex - 1]?.page;
    const pagination = document.getElementById('playbook__main__nav-links');

    const preNavLink = prevPage ? `
    <a href="${prevPage.url}"
    data-tracking='{
        "event": "Interaction",
        "event_type": "Playbook Nav",
        "event_detail": "Previous",
        "event_value": "${prevPage.title}"
    }'>
        <span>${prevPage.title}</span>
    </a>` : '';

    const nextNavLink = nextPage ? `
    <a href="${nextPage.url}"
    class="playbook__main__nav-links__next"
    data-tracking='{
        "event": "Interaction",
        "event_type": "Playbook Nav",
        "event_detail": "Next",
        "event_value": "${nextPage.title}"
    }'>
        <span>${nextPage.title}</span>
    </a>` : '';

    // Add the links to the pagination element
    pagination.innerHTML = preNavLink + nextNavLink;
}

